import { render, staticRenderFns } from "./UploadContentQuestion.vue?vue&type=template&id=18c965a6"
import script from "./UploadContentQuestion.vue?vue&type=script&lang=js"
export * from "./UploadContentQuestion.vue?vue&type=script&lang=js"
import style0 from "./UploadContentQuestion.vue?vue&type=style&index=0&id=18c965a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports